import { render, staticRenderFns } from "./tre-one.vue?vue&type=template&id=2a1b6b87&scoped=true&"
import script from "./tre-one.vue?vue&type=script&lang=js&"
export * from "./tre-one.vue?vue&type=script&lang=js&"
import style0 from "./tre-one.vue?vue&type=style&index=0&id=2a1b6b87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1b6b87",
  null
  
)

export default component.exports